import { fetchNodeConfig } from "../network/RouteNetworkAPI";
import {
  GET_CAPABILITIES,
  GET_STATION_CONFIG,
  RECEIVE_STATION_CONFIG,
  RECEIVE_REFRESH_INTERVAL,
} from "../utils/ReducerActionTypes";

export const CapabilityReducer = (state, action) => {
  switch (action.type) {
    case GET_CAPABILITIES:
      return { ...state, ...action.data };
    case GET_STATION_CONFIG:
      const { dispatcher } = action.data;
      fetchNodeConfig(dispatcher);
      return state;
    case RECEIVE_STATION_CONFIG:
      return { ...state, ...action.data };
    case RECEIVE_REFRESH_INTERVAL:
      return {
        ...state,
        stationConfig: {
          ...state.stationConfig,
          refreshInterval: action.data.refreshInterval,
        },
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/components/RouteStatus/reducers/CapabilityReducer.js